<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                     :size="GCONFIG.styleElFormSize">
                <el-form-item label="活动">
                    <el-select v-model="formInline.bindCode" clearable filterable placeholder="活动">
                        <el-option
                                v-for="item in activeOptions"
                                :key="item.bindCode"
                                :label="item.activeName"
                                :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="add()">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="pageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="40"></el-table-column>
                <el-table-column label="bindCode" width="180" prop="bindCode"></el-table-column>
<!--                <el-table-column prop="activeName" label="活动名称" width="170"></el-table-column>-->
                <el-table-column prop="luckyDrawName" label="抽奖名称" width="170"></el-table-column>
                <el-table-column prop="period" label="期次" width="90"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="150">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.createTime)}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="beginTime" label="开始时间" width="150">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.beginTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="150">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.endTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="openTime" label="开奖时间" width="150">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.openTime)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80" :formatter="statusShow"  sortable>

                </el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size="mini" @click="editData(scope.row)">编辑</el-button>
                            <el-button type="warning" size="mini" @click="deleteData(scope.row)">删除</el-button>

                            <el-button type="info" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                            <el-button type="info" size="mini" @click="openLuckyDraw(scope.row)">手工开奖</el-button>

                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {luckydraw_delete ,getActiveForOptionListByType, luckydraw_list,openLuckyDraw} from "../../api/api";
    import Preview from "@/components/Preview";
    export default {
        components: {Preview},
        data() {
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.active.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.active.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            return {
                activeOptions: [],
                pageList:[],
                formInline: {
                    bindCode: this.$route.query.bindCode || '',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                showPreviewDialog: false,
                loading: true,
                statusData:[{id:0,name:"待开奖"},{id:1,name:"正在开奖"},{id:2,name:"已开奖"},{id:3,name:"无效"}],
                params:{},
                activeType:39,
                linkType:0,

            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            getActiveForOptionListByType({activeType:39}).then((res) => {
                this.activeOptions = res.data.value;
                this.formInline.bindCode=res.data.value[0].bindCode;
                this.getList();
            })


        },
        methods: {
            openLuckyDraw(row){
                this.$confirm('手工抽奖是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    openLuckyDraw({luckyDrawId:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            statusShow(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
                //return this.randData.name;

            },
            add(){
                //添加
                this.$router.push({
                    path: 'luckytabs',
                    name: 'luckytabs',
                    query: {
                        id:'',
                        luckyDrawName:'',
                        bindCode:this.formInline.bindCode
                    }
                })
            },
            editData(row){
                this.$router.push({
                    path: 'luckytabs',
                    name: 'luckytabs',
                    query: {
                        id:row.id,
                        luckyDrawName:row.luckyDrawName,
                        bindCode:row.bindCode
                    }
                })
            },
            deleteData(row){
                this.$confirm('删除抽奖, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    luckydraw_delete({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            getList(){
                this.loading = true;
                luckydraw_list(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.pageList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            handlePreActive(row){
                this.activeType =39;
                this.params = {bindCode: row.bindCode};
                this.showPreviewDialog = true;
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            reset(formName){
                this.$refs[formName].resetFields();
            },

            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-order {
        .customer-nick {
            margin: 0;
        }
        .el-table th {
            background: #f1f1f1;
            color: #222222;
        }
        .el-table__expanded-cell {
            background: #f5f5f5;
            text-align: left;
            padding: 7px 50px;
        }
        .el-table__expanded-cell:hover {
            background: #f5f5f5 !important;
        }
        .expand-title {
            width: 70px;
            color: #444548;
            line-height: 30px;
            text-align: right;
            margin-right: 10px;
            font-weight: 600;
        }
        .expand-flex, .expand-flex-con {
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
        .expand-flex-con {
            display: flex;
            flex-wrap: wrap;
            .expand-content {
                margin: 5px 10px 5px 0;
            }
        }
        .el-table__expand-icon > .el-icon {
            font-size: 16px;
            font-weight: bolder;
        }
        .el-divider--horizontal {
            margin: 10px 0;
        }
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/lucky/luckydrawList.vue